import { Injectable } from '@angular/core';
import { WorkOrderReportProxyService } from '../proxies/order/work-order-report.proxy.service';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderReportService {
  constructor(private readonly workOrderReporProxyService: WorkOrderReportProxyService) {}

  generatePdfReport(workOrderReference: string): void {
    //open the PDF report in a new tab
    this.workOrderReporProxyService.generatePdfReport(workOrderReference).subscribe({
      next: (response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      },
      error: (error) => {
        console.error('Error generating PDF report:', error);
      },
    });
  }
}
